import { classes as htmlClasses } from 'html-classes';
import { observer } from 'mobx-react-lite';

import { Typography } from '@workspace/ui/components/Typography';

import { company } from '~/company/Company';
import { createCategoryUrl } from '~/components/CategoryBlocks/utils';
import { useGlobal } from '~/hooks/useGlobal';

import { Card } from '../shared/Card';
import { GridView, resolveTileSpans, tileClassNames } from '../shared/GridView';
import type { BlockCommonProps } from '../shared/interfaces';
import { ViewAllButton } from '../shared/ViewAllButton';
import styles from './ListOfCategories1.module.scss';

const ListOfCategories1 = ({
  classes,
  category,
  priority = false,
}: BlockCommonProps) => {
  const { isMobile } = useGlobal();

  if (!category.subcategory.length || !category.subcategory[0]?.id) {
    return null;
  }

  const { titleClassName } = classes || {};

  const TitleComponent = isMobile
    ? Typography.Header100Medium
    : Typography.Header400Medium;

  return (
    <div className={styles.wrapper}>
      {category.subcategory.map((subcategory, index) => (
        <div className={styles.root} key={subcategory.id}>
          <div className={styles.head}>
            <TitleComponent
              as="h3"
              className={htmlClasses([styles.title, titleClassName])}
            >
              {subcategory.name}
            </TitleComponent>
            <ViewAllButton link={createCategoryUrl({ id: subcategory.id })} />
          </div>

          <GridView className={styles.content}>
            {subcategory.subcategory.map((thirdLvlCategory, itemIndex) => {
              const tileSize = company.tileSizeEnabled
                ? resolveTileSpans(thirdLvlCategory.tileSize)
                : 1;

              return (
                <Card
                  key={thirdLvlCategory.id}
                  category={thirdLvlCategory}
                  tileSize={tileSize}
                  priority={priority && index === 0 && itemIndex === 0}
                  classes={{
                    tileClassName: tileClassNames[tileSize],
                    titleClassName: styles.cardTitle,
                  }}
                />
              );
            })}
          </GridView>
        </div>
      ))}
    </div>
  );
};

export default observer(ListOfCategories1);
